import React from 'react';

const AboutPlace = () => {
  // Data about places in Ayodhya
  const placesData = [
    {
      name: "Ram Ki Paidi",
      img: "./Images/Places/RelaxPlace/ramKiPaidi.jpg",
      about: "Ram Ki Paidi is a sacred bathing ghat located on the banks of the Sarayu River in Ayodhya, India. It is a popular pilgrimage site where devotees come to take a holy dip in the river.",
      wekipedia: "https://en.wikipedia.org/wiki/Ram_Janmabhoomi",
      VID: "J-XibePtJbQ",
      lat: "26.795821661223048",
      lng: "82.19443112566178",
    },
    {
      name: "Guptar Ghat",
      img: "./Images/Places/RelaxPlace/guptarGhat.jpg",
      about: "Guptar Ghat is a sacred bathing ghat located on the banks of the Sarayu River in Ayodhya, India. It is believed to be the place where Lord Ram took Jal Samadhi, a divine departure into the river.",
      wekipedia: "https://en.wikipedia.org/wiki/Hanuman_Garhi",
      VID: "Tp7ja-tOkuA",
      lat: "24.457300",
      lng: "82.980470",
    },
    {
      name: "Military Temple",
      img: "./Images/Places/RelaxPlace/militaryTemple.jpg",
      about: "Military Temple is a place of worship dedicated to the Hindu gods, located in Ayodhya, Uttar Pradesh. It is frequented by both locals and tourists seeking spiritual solace.",
      wekipedia: "https://en.wikipedia.org/wiki/Kanak_Bhavan",
      VID: "6ulhQ1L1AJo",
      lat: "26.798020",
      lng: "82.199162",
    },
    {
      name: "Saryu Nadi",
      img: "./Images/Places/RelaxPlace/saryu_nadi.jpg",
      about: "Saryu Nadi is a sacred river that flows through the city of Ayodhya, India. It holds deep religious significance and is mentioned in various Hindu scriptures.",
      wekipedia: "https://en.wikipedia.org/wiki/Nageshwar_Nath_Temple",
      VID: "fXNQHOsiMZE",
      lat: "26.795821661223048",
      lng: "82.19443112566178",
    },
    {
      name: "Gulab Bari",
      img: "./Images/Places/RelaxPlace/gulab_bari.jpeg",
      about: "Gulab Bari is a historic garden located in Ayodhya, Uttar Pradesh. It is known for its lush greenery and beautiful floral arrangements, making it a popular spot for relaxation and leisure.",
      wekipedia: "https://en.wikipedia.org/wiki/Tulsi_Udyan",
      VID: "m-GRsN7cGik",
      lat: "26.798020",
      lng: "82.199162",
    },
    {
      name: "Lata Mangeshkar Chwak",
      img: "./Images/Places/RelaxPlace/latamangeskar_chwak.webp",
      about: "Lata Mangeshkar Chwak is a public square located in Ayodhya, India. It is named after the renowned Indian playback singer Lata Mangeshkar and serves as a popular meeting point for locals.",
      wekipedia: "https://en.wikipedia.org/wiki/Guptar_Ghat",
      VID: "70x5SR4TGDI",
      lat: "26.798020",
      lng: "82.199162",
    },
    {
      name: "Company Garden",
      img: "./Images/Places/RelaxPlace/company_garden.jpg",
      about: "Company Garden is a scenic park located in Ayodhya, India. It features lush green lawns, vibrant flower beds, and various recreational facilities, making it an ideal destination for families and nature lovers.",
      wekipedia: "https://en.wikipedia.org/wiki/Kanak_Bhavan",
      VID: "WSKFN7Z6Oic",
      lat: "26.798020",
      lng: "82.199162",
    },
    {
      name: "Ayodhya Railway Station",
      img: "./Images/Places/RelaxPlace/ayodhya_railway.jpg",
      about: "Ayodhya Railway Station is a major railway hub located in the city of Ayodhya, Uttar Pradesh. It connects the city to various parts of India and serves as an important transportation node for both passengers and goods.",
      wekipedia: "https://en.wikipedia.org/wiki/Nageshwar_Nath_Temple",
      VID: "08v9NtLJiGw",
      lat: "26.795821661223048",
      lng: "82.19443112566178",
    },
    {
      name: "Treta Ke Thakur",
      img: "./Images/Places/RelaxPlace/ramKiPaidi.jpg",
      about: "Treta Ke Thakur is a temple dedicated to Lord Ram located in Ayodhya, Uttar Pradesh. It is believed to be the birthplace of Lord Ram and is visited by millions of devotees every year.",
      wekipedia: "https://en.wikipedia.org/wiki/Tulsi_Udyan",
      VID: "J-XibePtJbQ",
      lat: "26.798020",
      lng: "82.199162",
    }
    // Add more places as needed
  ];

  return placesData;
};

export default AboutPlace;
